export enum Orientation {
  LANDSCAPE = 'Landscape',
  PORTRAIT = 'Portrait',
  LANDSCAPE_PORTRAIT = 'None',
  SQUARE = 'Square',
}

export default Orientation;
